export abstract class StateEvent<EVENT extends {messageType: string}> {
	constructor(protected readonly messageType: EVENT["messageType"]) {
		this.messageType = messageType;
	}

	listeners: ((event: EVENT) => void)[] = [];

	addListener(listener: (event: EVENT) => void) {
		this.listeners.push(listener);
	}

	removeListener(listener: (event: EVENT) => void) {
		const index = this.listeners.indexOf(listener);
		if (index >= 0) {
			this.listeners.splice(index, 1);
		}
	}

	protected abstract transmitToOtherProcesses(event: EVENT): void;

	/**
	 * Emit an event within this process without transmitting it to other processes.
	 * 
	 * When an event is received from another process, this method sends it to all
	 * listeners within the process.
	 * 
	 * To send an event to all listeners in this process and other processes, call
	 * `send` instead.
	 */
	emit(event: EVENT) {
		for (const listener of this.listeners) {
			listener(event);
		}
	}

	/**
	 * Sends an event to all listeners in this process and other processes.
	 * 
	 * To send to just this process (e.g. when receiving from another process),
	 * call `emit` instead.
	 * 
	 * @param event 
	 */
	send(eventWithMessageTypeOptional: Omit<EVENT, "messageType"> & {messageType?: EVENT["messageType"]}) {
		const event: EVENT = {messageType: this.messageType, ...eventWithMessageTypeOptional} as EVENT;
		this.emit(event);
		this.transmitToOtherProcesses(event);
	};
}
